// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1iY1f0oaMDLftKwzTZf3P3","basicInformationWrapper":"_2WQJPRWP0On6RTHZ_NX2O0","logoWrapper":"_3AD37jk6TD7KJSXJ46Zq3O","projectName":"tCyd7-Z-Ylr5Bqlk484ni","name":"_1Ce0cP7Mhrgp3Q0shaVY45","price":"_2l6SkOs4twEucJavRbatSH","propertyInformation":"od3xv-pVaYb6WK0fdgQPm","count":"foJbuMJ-BBXGS3PD36-EQ","addressWrapper":"_3Jw4d21tDe1kmVBPYVhH8c","addressLine":"_3VKBDI5eXLHjdwlWzRLaDa","contacts":"_3228O5bjBr3rA27_pqMTK8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/BasicInformation/BasicInformation.scss
// module id = 1710
// module chunks = 0